import './assets/index.css';

import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { router } from '@/router.ts';
import { WebSocketService } from '@/ws/WebSocketService.ts';
import { bootstrapDesktopClient, bootstrapWebView } from '@/boostrap.ts';
import { setDarkModeClass } from '@/utils/RandomUtils.ts';
import * as Sentry from '@sentry/vue';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(router).use(pinia).mount('#app');

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
});

setDarkModeClass();

WebSocketService.instance.connect();

if (window.electronApi) {
    bootstrapDesktopClient();
} else {
    bootstrapWebView();
}
